import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { LIMIT } from './main-layout.const';
import { AiList } from '../../core/ai/ai.model';

interface MainLayoutState {
  isLoading: boolean;
  query: string;
  count: number;
  limit: number;
  currentPage: number;
  activeItemIndex: number;
  aiQuestions: AiList;
  isCreatingAiQuestion: boolean;
}

const initialState: MainLayoutState = {
  isLoading: false,
  query: '',
  count: 0,
  limit: LIMIT,
  currentPage: 1,
  activeItemIndex: 0,
  aiQuestions: { list: [], count: 0 },
  isCreatingAiQuestion: false
};

export const MainLayoutStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ count, currentPage, limit }) => ({
    pagesCount: computed(() => Math.floor(count() / limit())),
    offset: computed(() => (currentPage() - 1) * limit())
  })),
  withMethods((store) => ({
    updateIsLoading: (isLoading: boolean) => {
      patchState(store, { isLoading });
    },
    updateCount: (count: number) => {
      patchState(store, { count });
    },
    updateCurrentPage: (currentPage: number) => {
      patchState(store, { currentPage });
    },
    updateLimit: (limit: number) => {
      patchState(store, { limit });
    },
    updateQuery: (query: string) => {
      patchState(store, { query });
    },
    updateActiveItemIndex: (activeItemIndex: number) => {
      patchState(store, { activeItemIndex });
    },
    updateAiQuestions: (aiQuestions: AiList) => {
      patchState(store, { aiQuestions });
    },
    updateIsCreatingAiQuestion: (isCreatingAiQuestion: boolean) => {
      patchState(store, { isCreatingAiQuestion });
    }
  }))
);
